// src/tutoriel/TutorielPanneau.jsx — « OÙ J'EN SUIS, QU'EST-CE QUI RESTE ».
//
// Sans lui, on abandonne au milieu d'un parcours sans savoir qu'on l'a
// abandonné. Deux visages : la liste des parcours quand aucun n'est ouvert,
// le sommaire du parcours en cours sinon.
//
// Une étape indisponible reste AFFICHÉE, avec sa raison. La cacher ferait
// croire que le parcours est plus court qu'il ne l'est chez le voisin — et on
// chercherait ce qu'on a mal fait.
import React from 'react';

const BI = ({ icon, style }) => <i className={`bi bi-${icon}`} style={style} />;

const ICONE = { faite: 'check-circle-fill', sautee: 'dash-circle' };

export default function TutorielPanneau({ tuto }) {
  const { panneauOuvert, fermerPanneau, parcoursDispo, actif, erreur, charge,
    ouvrir, allerA, ignorer, recommencer, pause } = tuto;
  if (!panneauOuvert) return null;

  const listeEtapes = actif ? actif.chapitres : null;
  let compteur = -1;

  return (
    <>
      <div className="tuto-panneau__fond" onClick={fermerPanneau} aria-hidden="true" />
      <aside className="tuto-panneau erp-drawer" role="dialog" aria-label="Tutoriels">
        <header className="tuto-panneau__tete">
          <h2 className="tuto-panneau__titre">Tutoriels</h2>
          <button type="button" className="tuto-panneau__x" onClick={fermerPanneau} aria-label="Fermer">
            <BI icon="x-lg" />
          </button>
        </header>

        <div className="tuto-panneau__corps">
          {!charge && <p className="tuto-panneau__muet"><BI icon="arrow-repeat" /> Chargement…</p>}
          {erreur && <p className="tuto-panneau__erreur">Le tutoriel n'a pas pu se charger — {erreur}</p>}

          {/* ── Aucun parcours ouvert : le choix ── */}
          {!actif && charge && parcoursDispo.map(p => (
            <div key={p.cle} className={`tuto-carte${p.accessible ? '' : ' tuto-carte--ferme'}`}>
              <div className="tuto-carte__nom">{p.libelle}</div>
              <div className="tuto-carte__accroche">{p.accroche}</div>
              {!p.accessible ? (
                <div className="tuto-carte__etat">{p.raison}</div>
              ) : (
                <>
                  {/* L'état se lit sur l'AVANCEMENT, pas sur le statut : un
                      parcours ignoré à mi-chemin est « en cours », pas « pas
                      commencé » avec 8 étapes faites. */}
                  <div className="tuto-carte__etat">
                    {p.statut === 'termine'
                      ? `Terminé${p.progression ? ` — ${p.progression.faites}/${p.progression.total}` : ''}`
                      : p.progression?.faites
                        ? `En cours — ${p.progression.faites}/${p.progression.total}`
                        : `Pas commencé — ${p.progression?.total || 0} étapes`}
                  </div>
                  <div className="tuto-carte__actions">
                    <button type="button" className="erp-btn erp-btn--primary erp-btn--sm" onClick={() => ouvrir(p.cle)}>
                      {p.statut === 'termine' ? 'Revoir' : p.progression?.faites ? 'Reprendre' : 'Commencer'}
                    </button>
                    {(p.progression?.faites > 0 || p.statut === 'termine') && (
                      <button type="button" className="erp-btn erp-btn--secondary erp-btn--sm"
                        onClick={() => { if (window.confirm('Recommencer efface votre progression sur ce parcours. Continuer ?')) recommencer(p.cle); }}>
                        Recommencer
                      </button>
                    )}
                  </div>
                  {p.statut !== 'ignore' && p.statut !== 'termine' && (
                    <button type="button" className="tuto-carte__ignorer" onClick={() => ignorer(p.cle)}>
                      Ignorer ce tutoriel — il restera disponible ici.
                    </button>
                  )}
                </>
              )}
            </div>
          ))}

          {/* ── Un parcours ouvert : le sommaire ── */}
          {listeEtapes && listeEtapes.map(ch => (
            <section key={ch.cle} className="tuto-chap">
              <h3 className="tuto-chap__titre">{ch.titre}</h3>
              {ch.etapes.map(e => {
                compteur += 1;
                const i = compteur;
                const courante = i === actif.index;
                const etat = !e.disponible ? 'indisponible' : (e.statut || (courante ? 'courante' : 'a_faire'));
                return (
                  <button key={e.cle} type="button" className="tuto-etape" data-etat={etat}
                    disabled={!e.disponible} title={e.disponible ? undefined : e.raison}
                    onClick={() => { allerA(i); fermerPanneau(); }}>
                    <BI icon={!e.disponible ? 'slash-circle' : (ICONE[e.statut] || (courante ? 'record-circle' : 'circle'))} />
                    <span className="tuto-etape__titre">{e.titre}</span>
                  </button>
                );
              })}
            </section>
          ))}

          {actif && (
            <div className="tuto-panneau__actions">
              <button type="button" className="erp-btn erp-btn--secondary erp-btn--sm" onClick={pause}>
                Mettre en pause
              </button>
            </div>
          )}
        </div>
      </aside>
    </>
  );
}
